import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { resumeImportCotasPolling } from '@redux/slices/import-cotas';
import { AppDispatch } from '@redux/store';

export const useResumeImportCotas = () => {
    const dispatch = useDispatch<AppDispatch>();
    const dispatched = useRef(false);

    useEffect(() => {
        if (dispatched.current) return;
        dispatched.current = true;
        dispatch(resumeImportCotasPolling());
    }, [dispatch]);
};
